import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { formatSql } from '../pharmacyReportsHelpers.js';
import { DataFetchLoader } from '../../../../components/Loader.js';

function ReportSqlModal({ isOpen, reportName, sqlText, isLoading, onClose }) {
    return (
        <Modal isOpen={isOpen} toggle={onClose} size="lg" centered>
            <ModalHeader toggle={onClose}>{reportName} SQL</ModalHeader>
            <ModalBody>
                {isLoading ? (
                    <DataFetchLoader name="Loading SQL..." />
                ) : (
                    <pre className="pharmacy-reports-sql">{formatSql(sqlText)}</pre>
                )}
            </ModalBody>
        </Modal>
    );
}

export default ReportSqlModal;
